import { render, staticRenderFns } from "./FormaPagamentoManageRoute.vue?vue&type=template&id=2a476222"
import script from "./FormaPagamentoManageRoute.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoManageRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports